import React, { useState } from "react";
import { useContext } from "react";
import { withRouter } from "react-router-dom";
import { SD_Context } from "../../context/sd-context";
import SdHomeComponentSlider from "../body/sd-home-template/sd-home-component-slider";
import "../../Utils/sd-styles/templeOverlay.scss";

const TmsTempleOverlay = ({ searchtemple, history, language }) => {
  const { templeData } = useContext(SD_Context);
  const [alpaFilter, setAlphaFilter] = useState("");
  const [category, setCategory] = useState("All");

  const filter = [
    "All",
    "A",
    "B",
    "C",
    "D",
    "E",
    "F",
    "G",
    "H",
    "I",
    "J",
    "K",
    "L",
    "M",
    "N",
    "O",
    "P",
    "Q",
    "R",
    "S",
    "T",
    "U",
    "V",
    "W",
    "X",
    "Y",
    "Z",
  ];
  const catgry = ["6A", "6B", "6C"];
  return (
    <div id="tms-overlay">
      <SdHomeComponentSlider grayscale={true} click={true} />
      <div className="temple-list">
        <div className="temples">
          <h2>All Temples</h2>{" "}
          <button
            onClick={() =>
              (document.getElementById("tms-overlay").style.display = "none")
            }
          >
            Close
          </button>
        </div>
        <div className="filterAlpha">
          {filter
            ?.filter((item) => item.id !== 1)
            ?.map((item, i) => {
              return (
                <div
                  key={i}
                  className={
                    item === alpaFilter
                      ? "alpahabetsActive"
                      : item === "All"
                      ? alpaFilter === ""
                        ? "alpahabetsActive"
                        : "alpahabets"
                      : "alpahabets"
                  }
                  onClick={() => {
                    setAlphaFilter(item === "All" ? "" : item);
                    setCategory(item === "All" ? "All" : category);
                  }}
                >
                  <p>{item}</p>
                </div>
              );
            })}
        </div>
        <div className="filterAlpha">
          {catgry?.map((item, i) => {
            return (
              <div
                key={i}
                className={
                  item === category
                    ? "alpahabetsActive"
                    : item === "All"
                    ? category === ""
                      ? "alpahabetsActive"
                      : "alpahabets"
                    : "alpahabets"
                }
                onClick={() => {
                  setCategory(item === "All" ? "All" : item);
                }}
              >
                <p>{item}</p>
              </div>
            );
          })}
        </div>
        <hr />
        <div className="temple-list-names">
          {templeData
            ?.filter((item) =>
              item?.name?.toLowerCase().includes(searchtemple?.toLowerCase())
            )
            ?.filter((item) =>
              item?.name[0]?.toLowerCase().includes(alpaFilter?.toLowerCase())
            )
            ?.map((item, i) => {
              let element = (
                <p
                  style={{ cursor: "pointer" }}
                  key={i + "temple-list"}
                  onClick={() => {
                    document.getElementById("tms-overlay").style.display =
                      "none";
                    history?.push(
                      `/${language}/temples/${item.shortName}/aboutTemple`
                    );
                  }}
                >
                  <span></span>
                  {item.name}-({item.shortName})
                </p>
              );
              if (category !== "All") {
                if (item?.templeCategory === category) {
                  return element;
                }
              } else {
                return element;
              }
            })}
        </div>
      </div>
    </div>
  );
};

export default withRouter(TmsTempleOverlay);
